// extracted by mini-css-extract-plugin
export default {"barContainer":"ChannelBar_barContainer__Vs4ai","barLabel":"ChannelBar_barLabel__pndZ+","barTrack":"ChannelBar_barTrack__RyBwP","barFill":"ChannelBar_barFill__z0bkO"};